import {
  useAuthenticateImpersonateAccount,
  useImpersonate,
} from '@hooks/impersonate';
import { Routes } from '@routes';
import { Button, TopBar } from '@shopify/polaris';
import { useRouter } from 'next/router';
import { FunctionComponent } from 'react';
import styled from 'styled-components';

const BrandContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  margin-left: 1.5rem;
`;

const BrandName = styled.div`
  font-weight: 500;
`;

const BrandGid = styled.div`
  font-size: 12px;
`;

const TopBarWrapper = styled.div`
  color: #fff;
  .Polaris-TopBar {
    background-color: ${({ theme }) => theme.colors.destructive.hex};
    color: #fff;

    .Polaris-Button {
      min-width: 200px;
      margin-right: 1.5rem;
    }
  }
`;

export const ImpersonatorBar: FunctionComponent<any> = () => {
  const router = useRouter();
  const { impersonateAccount, logOut } = useImpersonate();
  useAuthenticateImpersonateAccount(impersonateAccount?.gid);

  const onLogOut = () => {
    logOut();
    router.push(Routes.overview);
  };

  if (!impersonateAccount) return <></>;

  const contextControlMarkup = (
    <BrandContainer>
      <BrandName> {impersonateAccount.name}</BrandName>
      <BrandGid>{impersonateAccount.gid}</BrandGid>
    </BrandContainer>
  );

  if (!impersonateAccount) return <></>;

  return (
    <TopBarWrapper>
      <TopBar
        showNavigationToggle
        secondaryMenu={
          <Button primary onClick={() => onLogOut()}>
            Stop Impersonating
          </Button>
        }
        contextControl={contextControlMarkup}
      />
    </TopBarWrapper>
  );
};
